import { render } from "./TutorialTooltip.vue?vue&type=template&id=8bc52b60&scoped=true"
import script from "./TutorialTooltip.vue?vue&type=script&lang=js"
export * from "./TutorialTooltip.vue?vue&type=script&lang=js"

import "./TutorialTooltip.vue?vue&type=style&index=0&id=8bc52b60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc52b60"]])

export default __exports__